import { useContext } from 'react';

import type { BackBehaviorOverride } from './BackBehaviorOverride';
import { BackBehaviorOverrideContext } from './BackBehaviorOverrideContext';

export function useSetBackBehaviorOverride(): (value: BackBehaviorOverride | null) => void {
	return useContext(BackBehaviorOverrideContext).setOverride;
}
